import { DataState, isEmpty } from './data-state';

/** The view-state a state-aware outlet resolves a slot for. `content` means "no state slot — render the node itself". */
export type SchemaViewState = 'loading' | 'empty' | 'error' | 'content' | (string & {});

/**
 * Maps a {@link DataState} onto the view-state used to look up a `states` slot.
 *
 * `loading` and `error` map straight through, a `loaded` state splits into `empty` / `content` by {@link isEmpty},
 * and any other status (including a custom one a data source emits) is used verbatim as the slot key.
 */
export function deriveSchemaViewState(state: DataState | undefined): SchemaViewState {
  switch (state?.status) {
    case 'loading':
      return 'loading';
    case 'error':
      return 'error';
    case 'loaded':
      return isEmpty(state.data) ? 'empty' : 'content';
    default:
      return state?.status ?? 'content';
  }
}
